
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/place/[id]/quote",
      function () {
        return require("private-next-pages/place/[id]/quote.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/place/[id]/quote"])
      });
    }
  